<template>
  <div class="page-sidebar sidebar-width-narrow">
    <!-- Header Slot -->
    <div v-if="$slots.header" class="sidebar-header">
      <slot name="header">
        <h2 class="sidebar-title">{{ title }}</h2>
      </slot>
    </div>

    <!-- Divider (optional) -->
    <div v-if="showDivider" class="sidebar-divider"></div>

    <!-- Body Slot -->
    <div class="sidebar-body">
      <slot name="body">
        <!-- Default Content -->
      </slot>
    </div>

    <!-- Footer Slot (optional) -->
    <div v-if="$slots.footer" class="sidebar-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageSidebar',

  props: {
    title: {
      type: String,
      default: 'Overview'
    },
    showDivider: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: 'auto',
      validator: (value) => ['auto', 'narrow', 'wide'].includes(value)
    }
  },

  computed: {
    sidebarWidthClass() {
      return `sidebar-width-${this.width}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.page-sidebar {
  width: 100%;
  // background-color: #fafafa;
  display: none;
  flex-basis: 30%;
  flex-direction: column;

  @media (min-width: 1280px) {
    display: flex;
    // background-color: white;
    padding: 2rem 0.5rem 2rem 0.5rem;
  }

  // Width variants
  &.sidebar-width-auto {
    @media (min-width: 1280px) {
      width: 384px;
    }

    @media (min-width: 1280px) {
      width: 420px;
    }
  }

  &.sidebar-width-narrow {
    @media (min-width: 1280px) {
      width: 320px;
      max-width: 15rem;
    }
  }

  &.sidebar-width-wide {
    @media (min-width: 1280px) {
      width: 480px;
    }

    @media (min-width: 1280px) {
      width: 520px;
    }
  }
}

.sidebar-header {
  margin-bottom: 32px;

  @media (min-width: 1280px) {
    margin-bottom: 48px;
  }
}

.sidebar-title {
  font-size: 24px;
  font-weight: 300;
  color: var(--color-foreground);
  margin: 0;

  @media (min-width: 1280px) {
    font-size: 32px;
  }

  @media (min-width: 1280px) {
    font-size: 36px;
  }
}

.sidebar-divider {
  height: 2px;
  background-color: var(--bs-border-color);
  width: 100%;
  margin-bottom: 24px;
}

.sidebar-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 12rem;
  max-width: 14rem;
}

.sidebar-footer {
  margin-top: auto;
  padding-top: 24px;
  border-top: 1px solid var(--bs-border-color);
}
</style>
